import { __rest } from "tslib";
import classNames from 'classnames';
import React from 'react';
import s from './spinner.module.css';
var sizes = {
  s: {
    px: 24,
    strokeWidth: 2,
    d: 'M21 12C21 7.02944 16.9706 3 12 3'
  },
  m: {
    px: 40,
    strokeWidth: 3,
    d: 'M36 20C36 11.1634 28.8366 4 20 4'
  },
  l: {
    px: 60,
    strokeWidth: 4,
    d: 'M56 30C56 15.6406 44.3594 4 30 4'
  }
};
export var Spinner = function Spinner(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    _ref$velocity = _ref.velocity,
    velocity = _ref$velocity === void 0 ? 'normal' : _ref$velocity,
    dataTest = _ref.dataTest;
  var _a = sizes[size],
    px = _a.px,
    path = __rest(_a, ["px"]);
  return React.createElement("div", {
    "data-spinner": true,
    className: classNames(s.box, s[color], s[size], s[velocity]),
    "data-test": dataTest
  }, React.createElement("svg", {
    width: px,
    height: px,
    viewBox: "0 0 ".concat(px, " ").concat(px),
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", Object.assign({
    stroke: "currentColor",
    strokeLinecap: "round"
  }, path, {
    fill: "none"
  }))));
};